import React from "react";
import { forwardRefAs, Generic } from "../../base";
export var Checkbox = forwardRefAs(function (props, ref) {
  return React.createElement(Generic, Object.assign({
    ref: ref,
    type: "checkbox"
  }, props));
}, {
  as: "input"
});
Checkbox.displayName = "Checkbox";